module.exports = __webpack_public_path__ + "img/ltkbump-1x.b867a50.jpg";